import { FC, KeyboardEvent, ReactNode } from "react";
import cx from "classnames";
import { ProviderMapResults } from "@app/projects/results/common/mapping";

export interface ZipProviderCardProps {
  provider: ProviderMapResults;
  isSelected: boolean;
  /** Extra class for out-of-network impact color-coding (202347, AC#5). Network cards omit it. */
  statusClassName?: string;
  onClick: (provider: ProviderMapResults) => void;
  children?: ReactNode;
}

/**
 * Base provider card for the Zip Provider Listing panel.
 */
export const ZipProviderCard: FC<ZipProviderCardProps> = ({ provider, isSelected, statusClassName, onClick, children }) => {
  const handleClick = (): void => onClick(provider);
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(provider);
    }
  };

  return (
    <div
      className={cx(
        "zip-coverage-map__provider-card",
        statusClassName,
        { "zip-coverage-map__provider-card--selected": isSelected },
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <h6>{provider.displayName}</h6>
      <p>{provider.address}, {provider.city}, {provider.state} {provider.zip}</p>
      <p><strong>NPI:</strong> {provider.npi}</p>
      {children}
    </div>
  );
};

export default ZipProviderCard;
